import * as React from 'react';
import { withRouter } from 'react-router';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { ComponentWithInjectedProps } from 'utils/injectedProps';
import Tabs from '@material-ui/core/Tabs';
import styles from '../ExtendedUiElements/customized.module.scss';
import { SyntheticEvent } from 'react';
import type { RouteComponentProps } from 'react-router-dom';

type TabProps = {
  onChange: Function,
  children: React.ReactElement,
  defaultTab?: number,
} & RouteComponentProps;

@observer
@withRouter
export class ElectroURLTabs extends ComponentWithInjectedProps<TabProps, {}, {}> {
  @observable tab = 0;

  constructor(props) {
    super(props);

    if (props.location.state) {
      this.tab = props.location.state.tab;
    } else if (props.defaultTab) {
      this.tab = props.defaultTab;
    } else {
      this.tab = 0;
    }

    props.history.replace({
      search: `tab=${this.tab}`,
      state: { tab: this.tab },
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    this.tab = this.props.location.state?.tab || 0;
  }

  changeTab(value) {
    this.tab = value;

    this.props.history.replace({
      search: `tab=${this.tab}`,
      state: { tab: this.tab },
    });
  }

  onChange(event: SyntheticEvent, value) {
    const { onChange } = this.props;
    this.changeTab(value);
    if (onChange) onChange(value);
  }

  render() {
    return (
      <Tabs
        {...this.props}
        className={styles['elr-tabs']}
        value={this.tab}
        onChange={this.onChange.bind(this)}
      >
        {this.props.children}
      </Tabs>
    );
  }
}
